export const uniqBy = (arr, key) => {
    if (!Array.isArray(arr) || !key) {
        return arr
    }

    return arr.filter((item, i, array) => array.findIndex(_item => _item[key] === item[key]) === i);
};

export const includesAny = (array, values) => {
    if (!array || !array?.length || !values) {
        return false;
    }

    return values.some((value) => array.includes(value));
};
